/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} Mellow_Fair_Camel_TwistInputs */

const fr_mellow_fair_camel_twist = /** @type {(inputs: Mellow_Fair_Camel_TwistInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer MFA de ${i?.username}`)
};

/**

* @param {Mellow_Fair_Camel_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mellow_fair_camel_twist = /** @type {((inputs: Mellow_Fair_Camel_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mellow_Fair_Camel_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mellow_fair_camel_twist(inputs)
});